import {
	vacancytitleByID,
	vacancytitleCreate,
	vacancytitleDestroy,
	vacancytitlesList,
	vacancytitleUpdate,
} from '@/services/jobs/vacancyTitle.service'

export default {
	namespaced: true,
	state: {
		// VACANCYTITLES
		vacancytitlesList: {},
		vacancytitle: {},
		// STATUS VACANCYTITLE
		vacancytitlesStatus: 'pending',
		vacancytitlesSaveStatus: 'init',
		vacancytitlesDeleteStatus: 'init',
	},
	getters: {
		// VACANCYTITLE
		getVacancytitlesList(state) {
			return state.vacancytitlesList
		},
		getVacancytitle(state) {
			return state.vacancytitle
		},
		// VACANCYTITLE
		getVacancytitlesDeleteStatus(state) {
			return state.vacancytitlesDeleteStatus
		},
		getVacancytitlesSaveStatus(state) {
			return state.vacancytitlesSaveStatus
		},
		getVacancytitlesStatus(state) {
			return state.vacancytitlesStatus
		},
	},
	mutations: {
		// VACANCYTITLES
		VACANCYTITLES_LIST(state, value) {
			state.vacancytitlesList = value
		},
		SET_VACANCYTITLE(state, value) {
			state.vacancytitle = value
		},
		// STATUS VACANCYTITLES
		VACANCYTITLES_STATUS(state, value) {
			state.vacancytitlesStatus = value
		},
		VACANCYTITLE_SAVE_STATUS(state, value) {
			state.vacancytitlesSaveStatus = value
		},
		VACANCYTITLE_DELETE_STATUS(state, value) {
			state.vacancytitlesDeleteStatus = value
		},
	},
	actions: {
		// Vacancytitles
		async fetchVacancytitleList({ commit }, params) {
			console.log('params', params)
			commit('VACANCYTITLES_STATUS', 'pending')
			commit('VACANCYTITLES_LIST', {})
			try {
				const { data } = await vacancytitlesList(params)
				console.log(data)
				commit('VACANCYTITLES_STATUS', 'init')
				commit('VACANCYTITLES_LIST', data)
				return data
			} catch (error) {
				commit('VACANCYTITLES_STATUS', 'init')
				throw error
			}
		},
		async fetchVacancytitleByID({ commit }, params) {
			commit('VACANCYTITLES_STATUS', 'pending')
			try {
				const { data } = await vacancytitleByID(params)
				commit('VACANCYTITLES_STATUS', 'init')
				commit('SET_VACANCYTITLE', data.data)
				return data
			} catch (error) {
				commit('VACANCYTITLES_STATUS', 'init')
				this._vm.$root.$notify({
					message: error.response.data.message,
					type: 'danger',
				})
				return error
			}
		},
		async saveNewVacancytitle({ commit }, params) {
			commit('VACANCYTITLE_SAVE_STATUS', 'pending')
			try {
				const { data } = await vacancytitleCreate(params)
				commit('VACANCYTITLE_SAVE_STATUS', 'init')
				return data
			} catch (error) {
				commit('VACANCYTITLE_SAVE_STATUS', 'init')
				throw error
			}
		},
		async updateVacancytitle({ commit }, params) {
			commit('VACANCYTITLE_SAVE_STATUS', 'pending')
			try {
				const { data } = await vacancytitleUpdate(params)
				commit('VACANCYTITLE_SAVE_STATUS', 'init')
				return data
			} catch (error) {
				commit('VACANCYTITLE_SAVE_STATUS', 'init')
				throw error
			}
		},
		async deleteVacancytitleByID({ commit }, params) {
			commit('VACANCYTITLE_DELETE_STATUS', 'pending')
			try {
				const { data } = await vacancytitleDestroy(params)
				commit('VACANCYTITLE_DELETE_STATUS', 'init')
				return data
			} catch (error) {
				commit('VACANCYTITLE_DELETE_STATUS', 'error')
				this._vm.$root.$notify({
					message: error.response.data.message,
					type: 'danger',
				})
				return error
			}
		},
	},
}
